import { Controller } from '@hotwired/stimulus'

// Connects to data-controller='profile-form'
export default class extends Controller {
  static targets = ['dateFormatSelect'];

  connect() {
    this.changeOptionText();
  }

  changeOptionText() {
    const select = $(this.dateFormatSelectTarget);

    select.find('option').each((_, option) => {
      const $option = $(option);
      const locale = $option.val();
      const currentDateWithFormat = moment().locale(locale).format('L');

      $option.text(`${$option.text()} (${currentDateWithFormat})`);
    });
  }
}
